import { render, staticRenderFns } from "./selection.vue?vue&type=template&id=3dafa8b5&scoped=true"
import script from "./selection.vue?vue&type=script&lang=js"
export * from "./selection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dafa8b5",
  null
  
)

export default component.exports